import { ca } from '@cian/analytics';

export function trackSellersCarouselAgentClick(agentId: number): void {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Listing',
    action: 'click',
    label: 'media_agent_banner_carousel_to_company_card',
    page: {
      extra: {
        agentId,
      },
    },
  });
}
